import React, { useState } from 'react';
import { useRequest } from 'hooks';

import { Button } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

import Edit from './Edit';

const AWARD_TYPES = [
	{ value: 'attendance', name: 'Piedalījās' },
	{ value: 'award', name: 'Apbalvojums' }
];

const Award = ({ award }) => {
	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Store request
	const [, request] = useRequest('delete', `awards/${award.id}`);

	// Toggle modal's visibility
	const onModal = () => setModal(m => !m);

	// Handle submit event
	const onRemove = async (event) => {
		event.preventDefault();

		// Try to create award
		const [success, error] = await request();
	};

	return (
		<div className="p-2 border border-neutral-100 dark:border-neutral-700 rounded-lg flex items-center">
			<div className="flex-1">
				<Title title={AWARD_TYPES.find(a => a.value === award.type)?.name} />
				<p className="text-neutral-800 dark:text-neutral-100">{award.for}</p>
			</div>

			<div className="flex space-x-2">
				<Button
					icon="edit"
					square
					small
					theme="warning"
					onClick={onModal}
				/>
				
				<Button
					small
					square
					icon="delete"
					theme="danger"
					onClick={onRemove}
				/>
			</div>

			<Edit award={award} modal={modal} onModal={onModal} />
		</div>
	);
};

export default Award;